import { render, staticRenderFns } from "./SelectComboBoxArea.vue?vue&type=template&id=37fa0f9c&"
import script from "./SelectComboBoxArea.vue?vue&type=script&lang=ts&"
export * from "./SelectComboBoxArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports